/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { Fragment, useContext, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { connectHits } from 'react-instantsearch-dom'

import {
  SelectedFiltersContext,
  SelectedFiltersContextType,
} from '@components/context/SelectedFiltersContext'
import HitWithSessions from '@components/section/catalog/HitWithSessions'

import { AlgoliaCatalogCourseType } from '@src/interfaces/AlgoliaResultCourseType'
import AnalyticsClient from '@src/utils/AnalyticsClient'

type Props = {
  itemClass: string
  hits: AlgoliaCatalogCourseType[]
}
export function getHitCategory(category: {
  lvl0: string | string[]
  lvl1: string | string[]
  lvl2: string | string[]
}) {
  const { lvl0, lvl1, lvl2 } = category

  const category0 = (() => {
    if (typeof lvl0 === `string`) {
      return lvl0.split(`|`)[0]
    }

    if (!lvl0) {
      return ``
    }

    const cat = lvl0[0].split(`|`)
    return cat && cat.length > 0 ? cat[0] : ``
  })()
  const category1 = (() => {
    if (typeof lvl1 === `string`) {
      return lvl1.split(`|`)[1]
    }

    if (!lvl1) {
      return ``
    }

    const cat = lvl1[0].split(`|`)
    return cat && cat.length > 1 ? cat[1] : ``
  })()
  const category2 = (() => {
    if (!lvl2) {
      return ``
    }
    if (typeof lvl2 === `string`) {
      return lvl2.split(`|`)[2]
    }

    const cat = lvl2[0].split(`|`)

    return cat && cat.length > 2 ? cat[2] : ``
  })()

  return {
    item_category: category0.trim(),
    item_category2: category1.trim(),
    item_category3: category2.trim(),
  }
}

const SearchCatalogResultsHits = ({ hits, itemClass }: Props) => {
  const { t } = useTranslation(`catalog`)
  const selectedFilters = useContext<SelectedFiltersContextType>(SelectedFiltersContext)
  const cityFilter: string | null = selectedFilters.filters.has(`City`)
    ? String(selectedFilters.filters.get(`City`))
    : null

  useEffect(() => {
    if (hits.length > 0) {
      AnalyticsClient.track(`view_item_list`, {
        ecommerce: {
          items: hits.map((hit, index) => {
            return {
              item_name: hit.Name,
              item_id: hit.Id,

              // @ts-ignore
              item_brand: hit.Editors?.lvl0,

              // @ts-ignore
              ...getHitCategory(hit.Themes),
              index: index + 1,
            }
          }),
        },
      })
    }
  }, [hits])

  if (hits.length === 0) {
    return (
      <div className='text-sm text-gray-500 my-8'>
        <p>{t(`noResult`)}</p>
        <p>{t(`noResultTryEliminateFilter`)}</p>
      </div>
    )
  }
  return (
    <Fragment>
      {hits.map((hit, index) => (
        <div key={hit.objectID} className={itemClass}>
          <HitWithSessions hit={hit} cityFilter={cityFilter} index={index + 1} />
        </div>
      ))}
    </Fragment>
  )
}

export default connectHits(SearchCatalogResultsHits)
